import { render, staticRenderFns } from "./SaleType.vue?vue&type=template&id=78210584&scoped=true&"
import script from "./SaleType.vue?vue&type=script&lang=js&"
export * from "./SaleType.vue?vue&type=script&lang=js&"
import style0 from "./SaleType.vue?vue&type=style&index=0&id=78210584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78210584",
  null
  
)

export default component.exports